import { WithRepository } from '@/types/typings';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { AccommodationRepository } from '../repository/accommodation-repository';
import { useAccommodationRepository } from '../repository/use-accommodation-repository';
import { PropertyType } from '../types/ws/websocket-message';

type Params = {
  propertyId: string;
  roomTypeId?: string;
  propertyType: PropertyType;
};

export function useGetAccommodationById(params: Params) {
  const repository = useAccommodationRepository();
  const { data: listings } = useSuspenseQuery(
    useGetAccommodationById.options({ ...params, repository }),
  );
  return listings;
}

useGetAccommodationById.baseKey = 'Listing';

useGetAccommodationById.keys = (params: Params) =>
  [useGetAccommodationById.baseKey, { ...params }] as const;

useGetAccommodationById.options = ({
  repository,
  ...params
}: WithRepository<Params, AccommodationRepository>) =>
  queryOptions({
    queryKey: useGetAccommodationById.keys(params),
    queryFn: ({ signal }) =>
      repository.getListingById(
        {
          ...params,
          signal,
        },
        params.propertyType,
      ),
  });
